// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../auth/AuthContext";
// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Container,
//   Row,
//   Col,
//   ModalFooter,
//   Table,
//   Pagination,
//   PaginationItem,
//   PaginationLink,
// } from "reactstrap";

// // core components
// import Header from "components/Headers/Header";
// import { api } from "../../config/middleware";
// import {
//   API_GETUNITS,
//   API_GETPRODUCTS,
//   API_EDITSERVICE,
//   API_GETSERVICEPRODUCTS,
// } from "../../config/api";
// import { useSessionStore } from "../../stores/sessionStore";
// import Swal from "sweetalert2";

// const EditPackage = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const { user } = useAuth();
//   const role = (
//     user?.role ||
//     localStorage.getItem("role") ||
//     "user"
//   ).toLowerCase();
//   const orgId = useSessionStore((s) => s.profile?.orgId);

//   // ---- รับข้อมูลบริการจากหน้า list ----
//   const sv = state?.sv;
//   useEffect(() => {
//     if (!sv) {
//       navigate("/manage-package");
//     }
//   }, [sv, navigate, role]);

//   // ---- form state (prefill) ----
//   const [form, setForm] = useState({
//     name: sv?.svName ?? "",
//     qty: sv?.svQty ?? "",
//     price: sv?.svPrice ?? "",
//     leadtime: sv?.svLeadTime ?? "",
//     customerType: sv?.svType ?? "แพ็คเกจ", // แพ็คเกจ | รายชิ้น | ชั่งกิโล
//     unitId: "",
//     unitName: sv?.svUnit ?? "",
//   });

//   const customerTypeOptions = [
//     { value: "แพ็คเกจ", label: "แพ็คเกจ" },
//     { value: "รายชิ้น", label: "รายชิ้น" },
//     { value: "ชั่งกิโล", label: "ชั่งกิโล" },
//   ];

//   // ===== ดึง "หน่วย" =====
//   const [units, setUnits] = useState([]);
//   const [unitError, setUnitError] = useState("");

//   useEffect(() => {
//     let alive = true;
//     const fetchUnits = async () => {
//       if (!orgId) return;
//       setUnitError("");
//       try {
//         const res = await api.get(API_GETUNITS, { params: { ORGID: orgId } });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         if (alive)
//           setUnits(arr.map((u) => ({ id: u.unitId, name: u.unitName })));
//       } catch (err) {
//         if (alive) setUnitError(err?.message || "โหลดหน่วยไม่สำเร็จ");
//       }
//     };
//     fetchUnits();
//     return () => {
//       alive = false;
//     };
//   }, [orgId]);

//   // preselect unit ให้ตรงกับ sv.svUnit
//   useEffect(() => {
//     if (!form.unitName || !units?.length) return;
//     const found = units.find((u) => u.name === form.unitName);
//     if (found && form.unitId !== found.id) {
//       setForm((s) => ({ ...s, unitId: found.id }));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [units, form.unitName]);

//   const UnitChooser = () => {
//     if (unitError) return <div className="text-danger">{unitError}</div>;
//     return (
//       <div className="d-flex align-items-center flex-wrap">
//         {units.map((u) => {
//           const active = form.unitId === u.id;
//           return (
//             <Button
//               key={u.id}
//               type="button"
//               size="sm"
//               outline={!active}
//               color={active ? "primary" : "secondary"}
//               className="mr-2 mb-2 rounded-pill"
//               onClick={() =>
//                 setForm((s) => ({ ...s, unitId: u.id, unitName: u.name }))
//               }
//               aria-pressed={active}
//             >
//               {u.name}
//             </Button>
//           );
//         })}
//         <Input type="hidden" name="unitId" value={form.unitId || ""} />
//         <Input type="hidden" name="unitName" value={form.unitName || ""} />
//       </div>
//     );
//   };

//   // ===== ดึง "สินค้าทั้งหมด" =====
//   const [products, setProducts] = useState([]);
//   const [prodLoading, setProdLoading] = useState(false);
//   const [prodError, setProdError] = useState("");

//   useEffect(() => {
//     let alive = true;
//     const fetchProducts = async () => {
//       if (!orgId) return;
//       setProdLoading(true);
//       setProdError("");
//       try {
//         const res = await api.get(API_GETPRODUCTS, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         if (alive) setProducts(arr);
//       } catch (err) {
//         if (alive) setProdError(err?.message || "โหลดสินค้าล้มเหลว");
//       } finally {
//         if (alive) setProdLoading(false);
//       }
//     };
//     fetchProducts();
//     return () => {
//       alive = false;
//     };
//   }, [orgId]);

//   // ===== ดึง "สินค้าของบริการนี้" แล้วติ๊ก checkbox อัตโนมัติ =====
//   const [servicePdIds, setServicePdIds] = useState(new Set());
//   const [selected, setSelected] = useState(new Set()); // checkbox ที่เลือก

//   useEffect(() => {
//     let alive = true;
//     const fetchServiceProducts = async () => {
//       if (!orgId || !sv?.svId) return;
//       try {
//         const res = await api.get(API_GETSERVICEPRODUCTS, {
//           params: { ORGID: orgId, SVID: sv.svId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         const ids = new Set(arr.map((x) => x.pdId));
//         if (alive) setServicePdIds(ids);
//       } catch (err) {
//         console.error("GetServiceProducts error:", err);
//       }
//     };
//     fetchServiceProducts();
//     return () => {
//       alive = false;
//     };
//   }, [orgId, sv?.svId]);

//   // เมื่อ products หรือ servicePdIds พร้อม ให้ sync selected
//   useEffect(() => {
//     if (!products?.length) return;
//     const ids = products
//       .filter((p) => servicePdIds.has(p.pdId))
//       .map((p) => p.pdId);
//     setSelected(new Set(ids));
//   }, [products, servicePdIds]);

//   const toggleSelect = (id) =>
//     setSelected((prev) => {
//       const next = new Set(prev);
//       next.has(id) ? next.delete(id) : next.add(id);
//       return next;
//     });

//   const allChecked = products.length > 0 && selected.size === products.length;
//   const toggleAll = () =>
//     setSelected((prev) =>
//       prev.size === products.length
//         ? new Set()
//         : new Set(products.map((p) => p.pdId))
//     );

//   // ===== Submit (แก้ไข) =====
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   const handleSubmit = async () => {
//     try {
//       setSubmitting(true);
//       setSubmitError("");

//       if (!orgId) throw new Error("ไม่พบ ORGID");
//       if (!sv?.svId) throw new Error("ไม่พบ SVID");
//       if (!sv?.svCode) throw new Error("ไม่พบ SVCODE");
//       if (!form.name?.trim()) throw new Error("กรุณากรอกชื่อแพ็คเกจ/บริการ");
//       if (!form.unitName) throw new Error("กรุณาเลือกหน่วย");

//       const payload = {
//         SVID: sv.svId,
//         SVCODE: sv.svCode, // หรือจะให้แก้รหัสบริการเพิ่ม input ก็ได้
//         ORGID: orgId,
//         NAME: form.name?.trim(),
//         PRICE: Number(form.price || 0),
//         TYPE: form.customerType, // "แพ็คเกจ" | "รายชิ้น" | "ชั่งกิโล"
//         QTY: Number(form.qty || 0),
//         LEADTIME: Number(form.leadtime || 0),
//         UNIT: form.unitName, // ส่งเป็นชื่อหน่วยตามสเปก
//         PRODUCT: products.filter((p) => selected.has(p.pdId)), // array ของสินค้า
//       };

//       await api.post(API_EDITSERVICE, payload);

//       await Swal.fire({
//         icon: "success",
//         title: "อัปเดตสำเร็จ",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       navigate("/manage-package");
//     } catch (err) {
//       setSubmitError(err?.message || "บันทึกไม่สำเร็จ");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // ===== Pagination (ตารางสินค้า) =====
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 10;
//   const totalPages = Math.ceil(products.length / pageSize);
//   const paginatedProducts = products.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );
//   const start = products.length ? (currentPage - 1) * pageSize + 1 : 0;
//   const end = Math.min(currentPage * pageSize, products.length);

//   const handleCancel = () => {
//     navigate("/manage-package");
//   };

//   return (
//     <>
//       <Header />
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xs="12">
//             <Card className="bg-secondary shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="8">
//                     <h6 className="mb-0">แก้ไขบริการ</h6>
//                   </Col>
//                 </Row>
//               </CardHeader>

//               <CardBody>
//                 <Form
//                   onSubmit={(e) => {
//                     e.preventDefault();
//                     handleSubmit();
//                   }}
//                 >
//                   {/* ประเภทบริการ */}
//                   <Row>
//                     <Col lg="12">
//                       <FormGroup>
//                         {customerTypeOptions.map((o) => {
//                           const active = form.customerType === o.value;
//                           return (
//                             <Button
//                               key={o.value}
//                               type="button"
//                               size="sm"
//                               outline={!active}
//                               color={active ? "primary" : "secondary"}
//                               className="mr-2 mb-2 rounded-pill"
//                               onClick={() =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   customerType: o.value,
//                                 }))
//                               }
//                               aria-pressed={active}
//                             >
//                               {o.label}
//                             </Button>
//                           );
//                         })}
//                         <Input
//                           type="hidden"
//                           name="customerType"
//                           value={form.customerType}
//                         />
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   {/* ฟิลด์ตามประเภท */}
//                   {form.customerType === "แพ็คเกจ" && (
//                     <>
//                       <Row>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-name"
//                             >
//                               ชื่อแพ็คเกจ
//                             </label>
//                             <Input
//                               id="input-name"
//                               type="text"
//                               value={form.name}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, name: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-qty"
//                             >
//                               จำนวน
//                             </label>
//                             <Input
//                               id="input-qty"
//                               type="number"
//                               value={form.qty}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, qty: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-price"
//                             >
//                               ราคา(บาท)
//                             </label>
//                             <Input
//                               id="input-price"
//                               type="number"
//                               value={form.price}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   price: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label
//                               className="form-control-label"
//                               htmlFor="input-leadtime"
//                             >
//                               ระยะเวลา(วัน)
//                             </label>
//                             <Input
//                               id="input-leadtime"
//                               type="number"
//                               value={form.leadtime}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   leadtime: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                       </Row>

//                       <Row>
//                         <Col lg="12">
//                           <label className="form-control-label">หน่วย</label>
//                           <FormGroup className="mb-0">
//                             <UnitChooser />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                     </>
//                   )}

//                   {form.customerType === "รายชิ้น" && (
//                     <>
//                       <Row>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label className="form-control-label">
//                               ชื่อบริการ
//                             </label>
//                             <Input
//                               type="text"
//                               value={form.name}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, name: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                       <Row>
//                         <Col lg="12">
//                           <label className="form-control-label">หน่วย</label>
//                           <FormGroup className="mb-0">
//                             <UnitChooser />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                     </>
//                   )}

//                   {form.customerType === "ชั่งกิโล" && (
//                     <>
//                       <Row>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label className="form-control-label">
//                               ชื่อแพ็คเกจ
//                             </label>
//                             <Input
//                               type="text"
//                               value={form.name}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, name: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label className="form-control-label">จำนวน</label>
//                             <Input
//                               type="number"
//                               value={form.qty}
//                               onChange={(e) =>
//                                 setForm((s) => ({ ...s, qty: e.target.value }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label className="form-control-label">
//                               ราคา(บาท)
//                             </label>
//                             <Input
//                               type="number"
//                               value={form.price}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   price: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                         <Col lg="6">
//                           <FormGroup>
//                             <label className="form-control-label">
//                               ระยะเวลา(วัน)
//                             </label>
//                             <Input
//                               type="number"
//                               value={form.leadtime}
//                               onChange={(e) =>
//                                 setForm((s) => ({
//                                   ...s,
//                                   leadtime: e.target.value,
//                                 }))
//                               }
//                             />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                       <Row>
//                         <Col lg="12">
//                           <label className="form-control-label">หน่วย</label>
//                           <FormGroup className="mb-0">
//                             <UnitChooser />
//                           </FormGroup>
//                         </Col>
//                       </Row>
//                     </>
//                   )}

//                   <div className="select-all-mobile">
//                     <label className="form-control-label">เลือกทั้งหมด</label>
//                     <Input
//                       type="checkbox"
//                       className="round-checkbox"
//                       checked={allChecked}
//                       onChange={toggleAll}
//                       aria-label="เลือกทั้งหมด"
//                     />
//                   </div>
//                   {/* ตารางสินค้า */}
//                   <div className="table-responsive">
//                     <Table
//                       hover
//                       className="table table-modern mb-0 mt-3 product-table"
//                     >
//                       <thead className="thead-colored">
//                         <tr>
//                           <th className="checkbox-col">
//                             <div className="th-center">
//                               <Input
//                                 type="checkbox"
//                                 className="round-checkbox"
//                                 checked={allChecked}
//                                 onChange={toggleAll}
//                                 aria-label="เลือกทั้งหมด"
//                               />
//                             </div>
//                           </th>

//                           <th scope="col">รหัสสินค้า</th>
//                           <th scope="col">ชื่อสินค้า</th>
//                           <th scope="col" className="text-end pe-4">
//                             ราคาต่อชิ้น
//                           </th>
//                           <th scope="col" />
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {prodLoading && (
//                           <tr>
//                             <td colSpan={5} className="text-center py-4">
//                               กำลังโหลดสินค้า...
//                             </td>
//                           </tr>
//                         )}

//                         {!prodLoading && prodError && (
//                           <tr>
//                             <td
//                               colSpan={5}
//                               className="text-center text-danger py-4"
//                             >
//                               {prodError}
//                             </td>
//                           </tr>
//                         )}

//                         {!prodLoading &&
//                           !prodError &&
//                           products.length === 0 && (
//                             <tr>
//                               <td colSpan={5} className="text-center py-4">
//                                 ไม่พบสินค้า
//                               </td>
//                             </tr>
//                           )}

//                         {!prodLoading &&
//                           !prodError &&
//                           paginatedProducts.map((p) => (
//                             <tr key={p.pdId}>
//                               <td>
//                                 <Input
//                                   type="checkbox"
//                                   className="round-checkbox"
//                                   checked={selected.has(p.pdId)}
//                                   onChange={() => toggleSelect(p.pdId)}
//                                   aria-label={`เลือก ${p.pdName}`}
//                                 />
//                               </td>
//                               <td data-th="รหัสสินค้า">{p.pdCode}</td>
//                               <td data-th="ชื่อสินค้า">{p.pdName}</td>
//                               <td data-th="ราคาต่อชิ้น">
//                                 {Number(p.pdPrice ?? 0)}
//                               </td>
//                               <td />
//                             </tr>
//                           ))}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {/* Pagination + counter */}
//                   <div className="d-flex justify-content-between align-items-center mt-4">
//                     <div className="text-muted small">
//                       {products.length
//                         ? `แสดงสินค้า ${start}-${end} จากทั้งหมด ${products.length} รายการ`
//                         : `ไม่พบรายการ`}
//                     </div>

//                     <nav aria-label="Page navigation">
//                       <Pagination className="mb-0">
//                         <PaginationItem disabled={currentPage === 1}>
//                           <PaginationLink
//                             href="#"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               setCurrentPage((p) => Math.max(p - 1, 1));
//                             }}
//                           >
//                             <i className="fas fa-angle-left" />
//                           </PaginationLink>
//                         </PaginationItem>

//                         {Array.from(
//                           { length: totalPages },
//                           (_, i) => i + 1
//                         ).map((page) => (
//                           <PaginationItem
//                             key={page}
//                             active={page === currentPage}
//                           >
//                             <PaginationLink
//                               href="#"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 setCurrentPage(page);
//                               }}
//                             >
//                               {page}
//                             </PaginationLink>
//                           </PaginationItem>
//                         ))}

//                         <PaginationItem
//                           disabled={
//                             currentPage === totalPages || totalPages === 0
//                           }
//                         >
//                           <PaginationLink
//                             href="#"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               setCurrentPage((p) =>
//                                 Math.min(p + 1, totalPages)
//                               );
//                             }}
//                           >
//                             <i className="fas fa-angle-right" />
//                           </PaginationLink>
//                         </PaginationItem>
//                       </Pagination>
//                     </nav>
//                   </div>

//                   {/* error submit */}
//                   {submitError && (
//                     <div className="text-danger mt-3" role="alert">
//                       {submitError}
//                     </div>
//                   )}
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       <ModalFooter>
//         <Button color="secondary" onClick={handleCancel}>
//           ยกเลิก
//         </Button>
//         <Button color="warning" onClick={handleSubmit} disabled={submitting}>
//           {submitting ? "กำลังอัปเดต..." : "อัปเดต"}
//         </Button>
//       </ModalFooter>
//     </>
//   );
// };

// export default EditPackage;

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";

// core components
import Header from "components/Headers/Header";
import { api } from "../../config/middleware";
import {
  API_GETUNITS,
  API_GETPRODUCTS,
  API_EDITSERVICE,
  API_GETSERVICEPRODUCTS,
} from "../../config/api";
import { useSessionStore } from "../../stores/sessionStore";
import Swal from "sweetalert2";

const EditPackage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useAuth();
  const role = (
    user?.role ||
    localStorage.getItem("role") ||
    "user"
  ).toLowerCase();
  const orgId = useSessionStore((s) => s.profile?.orgId);

  // ---- รับข้อมูลบริการจากหน้า list ----
  const sv = state?.sv;
  useEffect(() => {
    if (!sv) {
      navigate("/manage-package");
    }
  }, [sv, navigate, role]);

  // ---- form state (prefill) ----
  const [form, setForm] = useState({
    name: sv?.svName ?? "",
    qty: sv?.svQty ?? "",
    price: sv?.svPrice ?? "",
    leadtime: sv?.svLeadTime ?? "",
    customerType: sv?.svType ?? "แพ็คเกจ", // แพ็คเกจ | รายชิ้น | ชั่งกิโล
    unitId: "",
    unitName: sv?.svUnit ?? "",
  });

  const customerTypeOptions = [
    { value: "แพ็คเกจ", label: "แพ็คเกจ" },
    { value: "รายชิ้น", label: "รายชิ้น" },
    { value: "ชั่งกิโล", label: "ชั่งกิโล" },
  ];

  // ===== ดึง "หน่วย" =====
  const [units, setUnits] = useState([]);
  const [unitError, setUnitError] = useState("");

  useEffect(() => {
    let alive = true;
    const fetchUnits = async () => {
      if (!orgId) return;
      setUnitError("");
      try {
        const res = await api.get(API_GETUNITS, { params: { ORGID: orgId } });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        if (alive)
          setUnits(arr.map((u) => ({ id: u.unitId, name: u.unitName })));
      } catch (err) {
        if (alive) setUnitError(err?.message || "โหลดหน่วยไม่สำเร็จ");
      }
    };
    fetchUnits();
    return () => {
      alive = false;
    };
  }, [orgId]);

  // preselect unit ให้ตรงกับ sv.svUnit
  useEffect(() => {
    if (!form.unitName || !units?.length) return;
    const found = units.find((u) => u.name === form.unitName);
    if (found && form.unitId !== found.id) {
      setForm((s) => ({ ...s, unitId: found.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [units, form.unitName]);

  const UnitChooser = () => {
    if (unitError) return <div className="text-danger">{unitError}</div>;
    return (
      <div className="d-flex align-items-center flex-wrap">
        {units.map((u) => {
          const active = form.unitId === u.id;
          return (
            <Button
              key={u.id}
              type="button"
              size="sm"
              outline={!active}
              color={active ? "primary" : "secondary"}
              className="mr-2 mb-2 rounded-pill"
              onClick={() =>
                setForm((s) => ({ ...s, unitId: u.id, unitName: u.name }))
              }
              aria-pressed={active}
            >
              {u.name}
            </Button>
          );
        })}
        <Input type="hidden" name="unitId" value={form.unitId || ""} />
        <Input type="hidden" name="unitName" value={form.unitName || ""} />
      </div>
    );
  };

  // ===== ดึง "สินค้าทั้งหมด" =====
  const [products, setProducts] = useState([]);
  const [prodLoading, setProdLoading] = useState(false);
  const [prodError, setProdError] = useState("");

  useEffect(() => {
    let alive = true;
    const fetchProducts = async () => {
      if (!orgId) return;
      setProdLoading(true);
      setProdError("");
      try {
        const res = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        if (alive) setProducts(arr);
      } catch (err) {
        if (alive) setProdError(err?.message || "โหลดสินค้าล้มเหลว");
      } finally {
        if (alive) setProdLoading(false);
      }
    };
    fetchProducts();
    return () => {
      alive = false;
    };
  }, [orgId]);

  // ===== ดึง "สินค้าของบริการนี้" แล้วติ๊ก checkbox อัตโนมัติ =====
  const [servicePdIds, setServicePdIds] = useState(new Set());
  const [selected, setSelected] = useState(new Set()); // checkbox ที่เลือก

  useEffect(() => {
    let alive = true;
    const fetchServiceProducts = async () => {
      if (!orgId || !sv?.svId) return;
      try {
        const res = await api.get(API_GETSERVICEPRODUCTS, {
          params: { ORGID: orgId, SVID: sv.svId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        const ids = new Set(arr.map((x) => x.pdId));
        if (alive) setServicePdIds(ids);
      } catch (err) {
        console.error("GetServiceProducts error:", err);
      }
    };
    fetchServiceProducts();
    return () => {
      alive = false;
    };
  }, [orgId, sv?.svId]);

  // เมื่อ products หรือ servicePdIds พร้อม ให้ sync selected
  useEffect(() => {
    if (!products?.length) return;
    const ids = products
      .filter((p) => servicePdIds.has(p.pdId))
      .map((p) => p.pdId);
    setSelected(new Set(ids));
  }, [products, servicePdIds]);

  const toggleSelect = (id) =>
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const allChecked = products.length > 0 && selected.size === products.length;
  const toggleAll = () =>
    setSelected((prev) =>
      prev.size === products.length
        ? new Set()
        : new Set(products.map((p) => p.pdId)),
    );

  // ===== Submit (แก้ไข) =====
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      setSubmitError("");

      if (!orgId) throw new Error("ไม่พบ ORGID");
      if (!sv?.svId) throw new Error("ไม่พบ SVID");
      if (!sv?.svCode) throw new Error("ไม่พบ SVCODE");
      if (!form.name?.trim()) throw new Error("กรุณากรอกชื่อแพ็คเกจ/บริการ");
      if (!form.unitName) throw new Error("กรุณาเลือกหน่วย");

      const payload = {
        SVID: sv.svId,
        SVCODE: sv.svCode, // หรือจะให้แก้รหัสบริการเพิ่ม input ก็ได้
        ORGID: orgId,
        NAME: form.name?.trim(),
        PRICE: Number(form.price || 0),
        TYPE: form.customerType, // "แพ็คเกจ" | "รายชิ้น" | "ชั่งกิโล"
        QTY: Number(form.qty || 0),
        LEADTIME: Number(form.leadtime || 0),
        UNIT: form.unitName, // ส่งเป็นชื่อหน่วยตามสเปก
        PRODUCT: products.filter((p) => selected.has(p.pdId)), // array ของสินค้า
      };

      await api.post(API_EDITSERVICE, payload);

      await Swal.fire({
        icon: "success",
        title: "อัปเดตสำเร็จ",
        timer: 1500,
        showConfirmButton: false,
      });

      navigate("/manage-package");
    } catch (err) {
      setSubmitError(err?.message || "บันทึกไม่สำเร็จ");
    } finally {
      setSubmitting(false);
    }
  };

  // ===== Pagination (ตารางสินค้า) =====
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const totalPages = Math.ceil(products.length / pageSize);
  const paginatedProducts = products.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );
  const start = products.length ? (currentPage - 1) * pageSize + 1 : 0;
  const end = Math.min(currentPage * pageSize, products.length);

  const handleCancel = () => {
    navigate("/manage-package");
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">แก้ไขบริการ</h6>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  {/* ประเภทบริการ */}
                  <Row>
                    <Col lg="12">
                      <FormGroup>
                        {customerTypeOptions.map((o) => {
                          const active = form.customerType === o.value;
                          return (
                            <Button
                              key={o.value}
                              type="button"
                              size="sm"
                              outline={!active}
                              color={active ? "primary" : "secondary"}
                              className="mr-2 mb-2 rounded-pill"
                              onClick={() =>
                                setForm((s) => ({
                                  ...s,
                                  customerType: o.value,
                                }))
                              }
                              aria-pressed={active}
                            >
                              {o.label}
                            </Button>
                          );
                        })}
                        <Input
                          type="hidden"
                          name="customerType"
                          value={form.customerType}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* ฟิลด์ตามประเภท */}
                  {form.customerType === "แพ็คเกจ" && (
                    <>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-name"
                            >
                              ชื่อแพ็คเกจ
                            </label>
                            <Input
                              id="input-name"
                              type="text"
                              value={form.name}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, name: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-qty"
                            >
                              จำนวน
                            </label>
                            <Input
                              id="input-qty"
                              type="number"
                              value={form.qty}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, qty: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-price"
                            >
                              ราคา(บาท)
                            </label>
                            <Input
                              id="input-price"
                              type="number"
                              value={form.price}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  price: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-leadtime"
                            >
                              ระยะเวลา(วัน)
                            </label>
                            <Input
                              id="input-leadtime"
                              type="number"
                              value={form.leadtime}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  leadtime: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <label className="form-control-label">หน่วย</label>
                          <FormGroup className="mb-0">
                            <UnitChooser />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  {form.customerType === "รายชิ้น" && (
                    <>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">
                              ชื่อบริการ
                            </label>
                            <Input
                              type="text"
                              value={form.name}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, name: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <label className="form-control-label">หน่วย</label>
                          <FormGroup className="mb-0">
                            <UnitChooser />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  {form.customerType === "ชั่งกิโล" && (
                    <>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">
                              ชื่อแพ็คเกจ
                            </label>
                            <Input
                              type="text"
                              value={form.name}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, name: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">จำนวน</label>
                            <Input
                              type="number"
                              value={form.qty}
                              onChange={(e) =>
                                setForm((s) => ({ ...s, qty: e.target.value }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">
                              ราคา(บาท)
                            </label>
                            <Input
                              type="number"
                              value={form.price}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  price: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">
                              ระยะเวลา(วัน)
                            </label>
                            <Input
                              type="number"
                              value={form.leadtime}
                              onChange={(e) =>
                                setForm((s) => ({
                                  ...s,
                                  leadtime: e.target.value,
                                }))
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <label className="form-control-label">หน่วย</label>
                          <FormGroup className="mb-0">
                            <UnitChooser />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  <div className="select-all-mobile">
                    <label className="form-control-label">เลือกทั้งหมด</label>
                    <Input
                      type="checkbox"
                      className="round-checkbox"
                      checked={allChecked}
                      onChange={toggleAll}
                      aria-label="เลือกทั้งหมด"
                    />
                  </div>

                  {/* error submit */}
                  {submitError && (
                    <div className="text-danger mt-3" role="alert">
                      {submitError}
                    </div>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          ยกเลิก
        </Button>
        <Button color="warning" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "กำลังอัปเดต..." : "อัปเดต"}
        </Button>
      </ModalFooter>
    </>
  );
};

export default EditPackage;
